<template>
    <div class="Index">
        <div class="topHeader">
            <layout-header></layout-header>
            <layout-nav ></layout-nav>
        </div>
        <div class="layout-main">
                    <div  class="layout-tab__view">
                        <el-tabs :value="activeIndex"
                                 type="border-card"
                                 class="el-tabs-card"
                                 v-if="routerList&&routerList.length"
                                 @tab-click='tabClick'
                                 @tab-remove='tabRemove'
                        >
                            <el-tab-pane
                                    :key="item.path"
                                    v-for="(item, index) in routerList"
                                    :label="item.title"
                                    :name="item.name"
                                    :closable="item.path!=='/home/desk.vue'"
                                    :class="item.path=='/home/desk.vue'? 'tab-home':''"
                                >
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                   <div class="layout-main__content">
                        <keep-alive >
                            <router-view :key="key + '_' + vc_lang" />
                        </keep-alive>
                   </div>

        </div>

    </div>
</template>

<script>
    //loyout布局
    import LayoutHeader from "@/components/Header"
    import LayoutNav from "@/components/Menu"
    import { mapState } from "vuex"
    import {mapActions} from "vuex"
    export default {
        name: 'Index',
        components:{
            LayoutHeader,
            LayoutNav
        },
        data(){
            return {
                vc_lang:sessionStorage.getItem("vc_lang")
            }
        },
        watch:{
            $route(to,from){
                         this.$store.commit('set_active_index',to.name)
                  },
            activeIndex(a,b){

                if (a!=b) {
                    let to = this.routerList.find((item) => {
                        return item.name == a.toString();
                    });

                    if(to) this.$router.push({path: to.path})
                }
            }

        },
        mounted() {
            this.isLogin();
            this.$bus.on("clearKeepAlive",this.clearKeepAlive);
            window.addEventListener("resize",this.onResize);
            this.onResize();
            this.vc_lang=sessionStorage.getItem("vc_lang")?sessionStorage.getItem("vc_lang"):'zh_cn';
            // console.log(this.routerList)
        },
        computed:{
            ...mapState(["routerList","activeIndex"]),
            key(){return this.$route.name},

        },

        methods: {
            ...mapActions([ "getSysPonsitionMenuOperation","getCurrentMenuId"]),
            onResize (){
                let height=window.innerHeight || document.documentElement.innerHeight || document.body.clientHeight;
               this.$root.main_height=height;

                let menuH=$(".el-menu").height()*1;
                $(".topHeader").height(64 + menuH);
                $(".layout-main").height( height - (64 + menuH));
                $(".layout-main__content").height( height - (64 + menuH) -36);
                this.$root.workSize.h=$(".layout-main__content").height();
                this.$root.workSize.w=$(".layout-main__content").width();

            },
            clearKeepAlive(fullUrl){
                this.$children.forEach((item)=>{
                    if (item.$vnode.data.key==fullUrl) {
                        this._myDestory(item);
                    }
                });

            },
            _myDestory( keepAliveComponent){
                var key =
                    keepAliveComponent.$vnode.key == null
                        ? keepAliveComponent.$vnode.componentOptions.Ctor.cid +
                        (keepAliveComponent.$vnode.componentOptions.tag
                            ? `::${keepAliveComponent.$vnode.componentOptions.tag}`
                            : "")
                        : keepAliveComponent.$vnode.key;
                var cache = keepAliveComponent.$vnode.parent.componentInstance.cache;
                var keys = keepAliveComponent.$vnode.parent.componentInstance.keys;
                if (cache[key]) {
                    if (keys.length) {
                        var index = keys.indexOf(key);
                        if (index > -1) {
                            keys.splice(index, 1);
                        }
                    }
                    delete cache[key];
                }
                keepAliveComponent.$destroy();
            },
            async isLogin() {
                if (!sessionStorage.getItem('loginuser')) {
                    setTimeout(() => {
                        this.$router.push({ path: "/login" });
                    }, 500);
                } else{
                    await this.getSysPonsitionMenuOperation(); // 获取菜单列表
                    await this.haveAuthority(); // 判断是否有页面权限
                    this.onResize();
                }

            },
            //判断是否有页面权限
            async haveAuthority() {
                let routeWhiteList = ["/", "/login","/home/desk.vue"]; // 路由白名单
                if (!routeWhiteList.includes(this.$route.path)) {
                    // 不在白名单的 需要判断是否拥有权限
                    let result = await this.getCurrentMenuId({ path: this.$route.path });
                    if (!result.state) {
                        this.$message({
                            type: "warning",
                            message: this.$t('tips_you_do_not_have_permission_for_the_current_page'),
                        });
                        this.$router.push({ path: "/Index.vue" });
                    }
                }
            },
            tabClick(tab){
                  this.$store.commit('set_active_index',tab.name);
              },
            tabRemove(tabName){
                   let routerTabObj = this.routerList.find((item) => {
                    return item.name == tabName;
                });
                 this.$store.commit('DEL_VISITED_VIEW', routerTabObj);
                 this.$bus.emit("clearKeepAlive",tabName);
                if(this.routerList.length==0){
                    this.$router.push({ path: "/home/desk.vue" });
                }
            },

        }
    }
</script>
<style  lang="scss" scoped>

    .Index{
        margin: 0px;
        overflow: hidden;
        height: calc(100vh - 0px);
    }
    .tec-lf{
        text-align: left;
    }


    .topHeader{
        /*position: fixed;*/
        width: 100%;
        height:100px;
        top: 0;
        left: 0;
    }
    .layout-main{
        position: relative;
        float: left;
        width: 100%;
        background-color: #ffffff;
        height: 100%  ;
        overflow: hidden;
     }

      .el-tabs-card {
          margin: 0;
          padding: 0;
          width: 100%;
          height: 36px;

          /deep/ .el-tabs__header {
              height: 32px;
          }



          /deep/  .el-tabs__item:hover {
              margin-top: 1px;
              padding: 0 20px;
             // width: 120px;
              height: 32px;
              color: #4a8587;
              position: relative;
              font-size: 15px;
              background-color: #e4e0e2; //修改背景色
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
              border-top: 1px solid #c6c8cb;
              border-right: 1px solid #c6c8cb;
          }

          /deep/   .el-tabs__item.is-active {
              margin-top: 1px;
              padding: 0 20px;
              // width: 120px;
              height: 32px;
              color: #774917;
              position: relative;
              font-size: 15px;
              background-color: #ffffff; //修改背景色
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
              border-left: 1px solid #c6c8cb;
              border-top: 1px solid #c6c8cb;
              border-right: 1px solid #c6c8cb;
          }

          /deep/ .el-tabs__item {
              margin-top: 1px;
              padding: 0 20px;
              height: 32px;
              // -webkit-box-sizing: border-box;
              // box-sizing: border-box;
              line-height: 32px;
              display: inline-block;
              //list-style: none;
              font-size: 15px;
              font-weight: 500;
              color: #303133;
              position: relative;
              //white-space: nowrap;
              //max-width: 130px;
              overflow: hidden;
              //text-overflow:ellipsis;
          }

            .el_scrollbasr__wrap{
                overflow-x: hidden;
            }


          .el-input__inner {
              font-size: 8pt;
              letter-spacing: inherit;
          }
          /deep/     .el-tabs__content {
              padding: 0px;
              height: 1px;
              border: 1px solid #ccd0dd;
              //  margin-top :-15px;
              overflow: hidden;
          }
          tab-home{
              background: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyMDAiIHZpZXdCb3g9IjAgMCAyMDAgMjAwIj48cGF0aCBmaWxsPSIjMjQ4NmZmIiBkPSJNMTQ1LjY1OSw2OC45NDljLTUuMTAxLTUuMjA4LTEzLjM3Mi01LjIwOC0xOC40NzMsMEw5OS40NzksOTcuMjMzIEw3MS43NzIsNjguOTQ5Yy01LjEtNS4yMDgtMTMuMzcxLTUuMjA4LTE4LjQ3MywwYy01LjA5OSw1LjIwOC01LjA5OSwxMy42NDgsMCwxOC44NTdsNDYuMTgsNDcuMTRsNDYuMTgxLTQ3LjE0IEMxNTAuNzU5LDgyLjU5OCwxNTAuNzU5LDc0LjE1NywxNDUuNjU5LDY4Ljk0OXoiLz48L3N2Zz4NCg==) no-repeat center/100%;

          }
      }
    .layout-tab__view {
        flex: 1;
        position: relative;
        width: 100%;
        height:36px ;
        overflow: hidden;
    }
  .layout-main__content {
        flex: 1;
        position: relative;
        width: 100%;
        height:calc(100% - 36px) ;
        overflow: hidden;
    }
</style>